const CREATE_ALERT_V3 = "alert-v3::create";
const CREATE_ALERT_V3_SUCCESS = "alert-v3::create::success";
const DELETE_ALERT_V3 = "alert-v3::delete";
const DELETE_ALERT_V3_SUCCESS = "alert-v3::delete::success";
const EDIT_ALERT_V3 = "alert-v3::edit";
const EDIT_ALERT_V3_SUCCESS = "alert-v3::edit::success";
const LOAD_ALERTS_V3_SUCCESS = "alert-v3::load-all::success";
const LOAD_ALERTS_V3_FAILURE = "alert-v3::load-all::failure";

export {
  CREATE_ALERT_V3,
  CREATE_ALERT_V3_SUCCESS,
  DELETE_ALERT_V3,
  DELETE_ALERT_V3_SUCCESS,
  EDIT_ALERT_V3,
  EDIT_ALERT_V3_SUCCESS,
  LOAD_ALERTS_V3_SUCCESS,
  LOAD_ALERTS_V3_FAILURE,
};
